// removed by extract-text-webpack-plugin
module.exports = {"LayeredText":"LayeredText__LayeredText___8EbG5","mainContainer":"LayeredText__mainContainer___28gs2","backgroundText":"LayeredText__backgroundText___1K_S_","first":"LayeredText__first___l6rU8","second":"LayeredText__second___ZAY_6","third":"LayeredText__third____Jw1Y","fourth":"LayeredText__fourth___1BMZx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPages/LayeredText/LayeredText.css
// module id = 205
// module chunks = 0